import React from 'react';
import { useTranslation, Trans } from 'react-i18next';

import Question from '../../../../ProductDetails/Series3CollarDetails/components/FAQ/Question';
import styles from '../../../../ProductDetails/Series3CollarDetails/components/FAQ/FAQ.module.scss';
import productInfoStyles from '../ProductInfo/ProductInfo.module.scss';
import classNames from 'classnames';

export default function FAQ() {
  const { t } = useTranslation();
  return (
    <div className={classNames(styles.container, productInfoStyles.faqContainer)}>
      <h2 className={styles.heading}>{t('faq')}</h2>
      <div>
        <Question
          title={t('can_i_give_my_dog_this_alongside_other_supplements_and_vitamins')}
          page="Supplements"
          index={0}
        >
          {t(
            'every_supplement_in_our_lineup_is_carefully_formulated_to_avoid_known_interactions_with_each_other_supporting_your_dogs_health_without_compromise_while_our_products_are_designed_with_safety_in_mind_its_always_a_good_idea_to_check_with_your_vet_when_combining_supplements_they_can_help_tailor_the_right_approach_for_your_dogs_unique_needs',
          )}
        </Question>
        <Question
          title={t('is_this_included_in_my_collar_membership_or_is_it_a_separate_bill')}
          page="Supplements"
          index={1}
        >
          <Trans i18nKey="fi_supplements_are_billed_independently_of_your_monthly_fi_collar_membership_and_can_be_purchased_as_an_auto_shipment_or_single_bag_order">
            {t(
              'fi_supplements_are_billed_independently_of_your_monthly_fi_collar_membership_and_can_be_purchased_as_an_auto_shipment_or_single_bag_order',
            )}
            <br />
            <br />
            {t(
              'for_auto_shipments_youll_receive_a_separate_bill_and_can_make_changes_to_your_shipping_frequency_outside_your_fi_collar_membership',
            )}
          </Trans>
        </Question>
        <Question title={t('what_is_my_level_of_commitment_for_auto_shipments')} page="Supplements" index={2}>
          <Trans i18nKey="auto_shipments_can_be_cancelled_at_anytime">
            {t('auto_shipments_can_be_cancelled_at_anytime')}
            <br />
            <br />
            {t(
              'reach_out_to_customer_service_or_modify_your_shipping_frequency_in_the_app_to_adjust_your_order_preferences',
            )}
          </Trans>
        </Question>

        <Question title={t('what_is_my_level_of_commitment')} page="Supplements" index={3}>
          <Trans i18nKey="this_is_an_ongoing_subscription_and_you_can_cancel_anytime">
            {t('this_is_an_ongoing_subscription_and_you_can_cancel_anytime')}
            <br />
            <br />
            {t('reach_out_to_customer_service_to_modify_your_subscription')}
          </Trans>
        </Question>
        <Question title={t('what_is_the_delivery_schedule')} page="Supplements" index={4}>
          {t(
            'youll_receive_your_first_order_soon_and_a_new_bag_will_arrive_every_1_to_12_weeks_depending_on_your_dogs_size_and_selected_auto_ship_frequency',
          )}
        </Question>
      </div>
    </div>
  );
}
